import React, { useState } from "react";
import { useGoogleLogin, useGoogleOAuth } from "@react-oauth/google";
import { toast } from "react-toastify";
import { userService } from "../../_services";
import { googleAccountErrorMessage } from "@crewmates/api-client-legacy";

const buttonClass = "tw-border-0 tw-p-2 tw-px-4 tw-py-2 tw-rounded-md tw-text-white tw-bg-[#23426e] tw-text-sm";

export default function GoogleAccountConnection({ onConnected }) {
  const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
  if (!clientId || !scriptLoadedSuccessfully) {
    return <button type="button" onClick={() => toast.error("Google connection is unavailable. Please try again later.")} className={buttonClass}>Connect Now</button>;
  }
  return <ReadyGoogleAccountConnection onConnected={onConnected} />;
}

function ReadyGoogleAccountConnection({ onConnected }) {
  const [connecting, setConnecting] = useState(false);
  const fail = () => {
    setConnecting(false);
    toast.error("Unable to connect Google. Please try again.");
  };
  const connect = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      if (!access_token) return fail();
      try {
        const result = await userService.updateSocialAuthenticationStatus({
          socialType: "Google",
          providerToken: access_token,
        });
        if (result.status) {
          toast.success(result.message);
          onConnected();
        } else {
          toast.error(result.message || "Unable to connect Google. Please try again.");
        }
      } catch (error) {
        toast.error(googleAccountErrorMessage(error, "Unable to connect Google. Please try again."));
      } finally {
        setConnecting(false);
      }
    },
    onError: fail,
    onNonOAuthError: fail,
  });

  return (
    <button
      type="button"
      disabled={connecting}
      onClick={() => {
        setConnecting(true);
        try { connect(); } catch { fail(); }
      }}
      className={buttonClass}
    >
      {connecting ? "Connecting..." : "Connect Now"}
    </button>
  );
}
